import api from '@/lib/api';

// ---------------------------------------------------------------------------
// E8 — SUPER_ADMIN cross-property parity rollup. Lives on the platform
// AdminChannelsController (/admin/platform/channels/parity, @PlatformRoute),
// because SUPER_ADMIN is fenced out of every tenant /channels/sync route.
// Oversight only — no push controls at the platform level.
// ---------------------------------------------------------------------------

const BASE = '/admin/platform/channels';

export interface AdminParityRow {
  propertyId: string;
  connectedOtas: number;
  externalChange: number;
  pushUnconfirmed: number;
  syncErrors: number;
  lastSyncedAt: string | null;
}

export async function fetchParityRollup(): Promise<AdminParityRow[]> {
  const { data } = await api.get<AdminParityRow[]>(`${BASE}/parity`);
  return data;
}
